// Blog post video (sections/site-main-article.liquid): give each pasted embed its own shape.
// Script embeds (TikTok, Instagram: a blockquote plus script) size themselves; they are marked
// is-script in Liquid already, and again here, before any iframe their script may have added.
// An iframe embed takes the shape of its width and height attributes; when those are missing,
// a wrapper with a percentage padding (Vimeo's default embed) gives the shape and is then made to
// fill the frame; otherwise 16:9. Taller-than-wide clips are marked vertical.
function sizeArticleVideos(root) {
  root.querySelectorAll('[data-article-video]').forEach((box) => {
    const frame = box.querySelector('iframe');
    if (box.classList.contains('is-script') || box.querySelector('script, blockquote') || !frame) {
      box.classList.add('is-script');
      return;
    }
    const width = Number(frame.getAttribute('width'));
    const height = Number(frame.getAttribute('height'));
    let ratio = width > 0 && height > 0 ? width / height : 0;
    if (!ratio) {
      for (let el = frame.parentElement; el && el !== box; el = el.parentElement) {
        const pad = parseFloat(el.style.paddingTop) || parseFloat(el.style.paddingBottom);
        if (pad > 0 && /%/.test(el.style.paddingTop + el.style.paddingBottom)) {
          ratio = 100 / pad;
          Object.assign(el.style, { padding: '0', position: 'absolute', inset: '0' });
          break;
        }
      }
    }
    ratio = ratio > 0 ? ratio : 16 / 9;
    box.style.setProperty('--ratio', ratio);
    box.classList.toggle('is-vertical', ratio < 1);
  });
}

sizeArticleVideos(document);
document.addEventListener('shopify:section:load', (event) => sizeArticleVideos(event.target));
